module.exports = __webpack_public_path__ + "img/Info-s-default.db62c8c3.svg";